import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { UiSelectOption } from '../select/select.component';
import { UiMultiselectComponent } from './multiselect.component';

const YEAR_OPTIONS: UiSelectOption[] = [
  { id: 2024, label: '2024' },
  { id: 2025, label: '2025' },
  { id: 2026, label: '2026' },
];

/**
 * Variante de ui-multiselect pre-configurada para selección múltiple de año.
 * Opciones fijas: 2024 · 2025 · 2026.
 * Uso: <ui-year-multiselect [(selected)]="selectedYears" />
 */
@Component({
  selector: 'ui-year-multiselect',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiMultiselectComponent],
  template: `
    <ui-multiselect
      placeholder="Año - Todos"
      [options]="yearOptions"
      [(selected)]="selected"
      [showLabel]="false"
      [showOptionalHint]="false"
      style="width: 200px"
    />
  `,
})
export class UiYearMultiselectComponent {
  protected readonly yearOptions = YEAR_OPTIONS;
  readonly selected = model<UiSelectOption[]>([]);
}
